import { Box } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { SelectedProvider } from '@uplift/pages';
import { TimezoneContext } from '@uplift/contexts';
import { ArrowBack } from '@mui/icons-material';
import { usePsychiatryMatchingContext } from './psychiatry-matching-context';
import { useStyles } from './styles';
import { DateObject } from '@uplift/services';
import { Button, ScrollableView } from '@uplift/ui-v2';
import { useUserInsurancesQuery, useUserProfileQuery } from '@uplift/queries';

export const PsychiatristProfile: React.VFC = () => {
  const l10n = useL10n();
  const { state, dispatch } = usePsychiatryMatchingContext();
  const { classes } = useStyles({ isDrawer: state.isDrawer });
  const selectedProvider = state.providers.find(x => x.user.id === state.selectedProvider);
  const { data: patientInsurances } = useUserInsurancesQuery(state.patientId);
  const patientInsuranceCompany = patientInsurances?.[0]?.insuranceCompany;
  const { data: patientProfile } = useUserProfileQuery(state.patientId);
  const patientTimezone = patientProfile?.timezone;

  const onScheduleSession = (selectedSlot: DateObject) => {
    dispatch({
      type: 'setAppointment',
      payload: {
        fromDatetime: selectedSlot,
        providerId: selectedProvider.user.id
      }
    });
  };

  const handleBack = () => {
    dispatch({
      type: 'changeStep',
      payload: 'connect',
    });
  };

  if (state?.isDrawer) {
    return (
      <>
        <Box p={1}>
          <Button startIcon={<ArrowBack fontSize="inherit" />} type="button" color="secondary" size="small" onClick={handleBack} className={classes.backButton}>
            {l10n.navigation.back}
          </Button>
        </Box>
        <TimezoneContext.Provider value={patientTimezone}>
          <SelectedProvider
            patientId={state.patientId}
            stateId={state.stateId}
            selectedProvider={state.selectedProvider}
            onScheduleSession={onScheduleSession}
            forceMobile
            appBarOffset={0}
            matchedInsuranceCompany={patientInsuranceCompany}
          />
        </TimezoneContext.Provider>
      </>
    );
  } else {
    return (
      <ScrollableView>
        <TimezoneContext.Provider value={patientTimezone}>
          <SelectedProvider
            patientId={state.patientId}
            stateId={state.stateId}
            selectedProvider={state.selectedProvider}
            onScheduleSession={onScheduleSession}
            matchedInsuranceCompany={patientInsuranceCompany}
            isScrollableView
          />
        </TimezoneContext.Provider>
      </ScrollableView>
    );
  }
};
